import { Box, Container } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { Stepper } from '@/components/stepper'
import { useCompanies } from '@/hooks/use-companies'

import { DemandAnalysisStoreProvider } from './contexts/demand-analysis-store-context'
import { EditPerimeter } from './steps/edit-perimeter'
import { Finish } from './steps/finish'
import { Info } from './steps/info'
import { Resume } from './steps/resume'
import { SelectFiles } from './steps/select-files'
import { Upload } from './steps/upload'
import { useStyles } from './styles'

const steps = {
  info: { component: Info, index: 0 },
  edit: { component: EditPerimeter, index: 1 },
  select_files: { component: SelectFiles, index: 1 },
  resume: { component: Resume, index: 2 },
  upload: { component: Upload, index: 3 },
  finish: { component: Finish, index: 4 },
}

export type Steps = keyof typeof steps

const stepsLabel = [
  'Informações do diagnóstico',
  'Editar arquivos',
  'Confirmar diagnóstico',
  'Carregar arquivos',
  'Finalizar cadastro',
]

const DemandAnalysis = () => {
  const classes = useStyles()
  const { selectedCompany } = useCompanies()

  const { step, companyId } = useParams<{ step: Steps; companyId: string }>()

  const isInvalidCompany = Number(companyId) !== selectedCompany.id
  const CurrentComponent = steps[step!]?.component

  if (!CurrentComponent || isInvalidCompany) return null

  return (
    <Box height='100%' minHeight='0' display='flex' flexDirection='column'>
      <Container className={classes.stepperContainer}>
        <Stepper activeStep={steps[step!]?.index} steps={stepsLabel} />
      </Container>

      <DemandAnalysisStoreProvider>
        <CurrentComponent />
      </DemandAnalysisStoreProvider>
    </Box>
  )
}

export default DemandAnalysis
